var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"window"},on:{"enter":_vm.enter}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._visible),expression:"_visible"}],staticClass:"wnd_outer",style:({
      width: this._width,
      height: this._height,
      left: this._x,
      top: this._y,
      zIndex: 999,
      minWidth: 300 + 'px',
      minHeight: 200 + 'px',
      maxWidth: _vm.windowWidth - 40 + 'px',
      maxHeight: _vm.windowHeight - 40 + 'px',
      overflow: 'hidden',
    })},[_c('div',{staticClass:"caption",on:{"mousedown":function($event){$event.preventDefault();return _vm.mousedown($event)}}},[_vm._v(" サマリー "),_c('i-icon',{staticClass:"close",attrs:{"size":"18","type":"ios-close"},on:{"click":_vm.closeButtonClicked}})],1),_c('div',{ref:"wndInner",staticClass:"wnd_inner"},[_c('ConvertContents',{attrs:{"type":_vm.type}})],1),_c('div',{staticClass:"mod_size",on:{"mousedown":_vm.startSizeChange}},[_c('span',{staticStyle:{"top":"4px","left":"-1px","width":"150%"}}),_c('span',{staticStyle:{"top":"9px"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }